import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { EyeSettings } from './EyeSettings';
import { LogoSettings } from './LogoSettings';
import { ModuleSettings } from './ModuleSettings';

export function CustomizationTabs() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Anpassung</CardTitle>
        <CardDescription>Module, Eckmarkierungen und Logo</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="modules">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="modules">Module</TabsTrigger>
            <TabsTrigger value="eyes">Ecken</TabsTrigger>
            <TabsTrigger value="logo">Logo</TabsTrigger>
          </TabsList>

          <TabsContent value="modules" className="pt-4">
            <ModuleSettings />
          </TabsContent>
          <TabsContent value="eyes" className="pt-4">
            <EyeSettings />
          </TabsContent>
          <TabsContent value="logo" className="pt-4">
            <LogoSettings />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
